import styles from "@/styles/sliderBarLeft.module.scss";
import Link from "next/link";
import Image from "next/image";
import { useEffect, useState } from "react";
import systemApi from "@/service/modules/systemApi";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const apiDomain = publicRuntimeConfig.apiDomain;

export default function SliderBarLeft() {
  const [email, setEmail] = useState("");
  const [imgUrl, setImgUrl] = useState("");

  useEffect(() => {
    const localImgUrl = sessionStorage.getItem("subscribeImageUrl");
    if (localImgUrl) {
      setImgUrl(localImgUrl);
    } else {
      // 如果没有缓存，请求接口获取图片数据
      const getBannersData = async () => {
        try {
          const res = await systemApi.getFullBanners();
          const { coupletBanner } = res.data.home;

          if (coupletBanner && coupletBanner.imgUrl) {
            setImgUrl(coupletBanner.imgUrl);
            sessionStorage.setItem("subscribeImageUrl", coupletBanner.imgUrl);
          }
        } catch (error) {
          // 如果接口请求失败，使用默认图片
          console.log("Failed to get subscribe image data:", error);
        }
      };

      getBannersData();
    }
  }, []);

  const handleEmailChange = (event: any) => {
    setEmail(event.target.value);
  };

  // 提交newsletters
  const handleSubmit = () => {
    let url = "/newsletters?email=";
    if (email) {
      url += email;
    } else {
      url += "Email+Address";
    }

    window.location.href = url;
  };

  function handlePageJump(url: string, e: any) {
    // 阻止a标签默认行为
    e.preventDefault();
    window.location.href = `${url}`;
  }

  return (
    <div
      className={styles["slider-bar-left"]}
      id="sliderBarLeft"
      style={{ display: imgUrl ? "block" : "none" }}
    >
      <Link href="/newsletters" legacyBehavior>
        <a onClick={(e: any) => handlePageJump(`${apiDomain}/newsletters`, e)}>
          <Image
            className={styles["main-img"]}
            src={imgUrl}
            alt="Subscribe"
            priority={true}
            width={95}
            height={282}
          ></Image>
        </a>
      </Link>
      <div className={styles["form-box"]}>
        <input
          className={styles["email-input"]}
          placeholder="Email Address"
          value={email}
          onChange={handleEmailChange}
        />
        <div className={styles["submit-btn"]} onClick={handleSubmit}>
          Subscribe
        </div>
      </div>
    </div>
  );
}
